// Should validate http: https: mailto: tel: ftp: file: ws: and others
const isAbsoluteUrl = (url?: string) => /^[a-z][a-z0-9+.-]*:/i.test(url as string);

export default isAbsoluteUrl;
